import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { CurrentUserService } from '®shared/current-user';
import { Permissions, hasPermissionForListId } from '®shared/permissions';
import {
  getNavigationExtrasForError,
  handleRenavigationError,
  idWithoutDotHtml,
} from '®shared/router';

import { ListResolverStoreService } from '../resolver-store';

@Injectable()
export class CanActivateViewListAsStudent implements CanActivate {
  constructor(
    private currentUserService: CurrentUserService,
    private listResolverStoreService: ListResolverStoreService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const listId = idWithoutDotHtml(route.params.listId);

    return this.currentUserService.getCurrentUser().pipe(
      mergeMap(currentUser => {
        const { permissions } = currentUser;

        // If you don't have permission to edit the list, redirect to list view
        if (
          !hasPermissionForListId(Permissions.EDIT_LIST, listId, permissions)
        ) {
          this.router.navigate(
            ['error'],
            getNavigationExtrasForError(403, 'Forbidden'),
          );
          return observableOf(false);
        }

        // If we find a published list, return true to allow access
        // If no published list is found, an error is thrown, and this is handled in catchError below
        return this.listResolverStoreService.hasPublishedReadingList(listId);
      }),
      catchError(handleRenavigationError(this.router)),
    );
  }
}
